export enum StorageFolder {
  DemoSpaces = 'demo-spaces',
}
